export var HistoryPeriodEnum;
(function (HistoryPeriodEnum) {
    HistoryPeriodEnum[HistoryPeriodEnum["ALL_TIME"] = -1] = "ALL_TIME";
    HistoryPeriodEnum[HistoryPeriodEnum["CURRENT_YEAR"] = 0] = "CURRENT_YEAR";
    HistoryPeriodEnum[HistoryPeriodEnum["ONE_DAY"] = 1] = "ONE_DAY";
    HistoryPeriodEnum[HistoryPeriodEnum["ONE_WEEK"] = 7] = "ONE_WEEK";
    HistoryPeriodEnum[HistoryPeriodEnum["ONE_MONTH"] = 30] = "ONE_MONTH";
    HistoryPeriodEnum[HistoryPeriodEnum["THREE_MONTHS"] = 90] = "THREE_MONTHS";
    HistoryPeriodEnum[HistoryPeriodEnum["SIX_MONTHS"] = 180] = "SIX_MONTHS";
    HistoryPeriodEnum[HistoryPeriodEnum["ONE_YEAR"] = 365] = "ONE_YEAR";
})(HistoryPeriodEnum || (HistoryPeriodEnum = {}));
//# sourceMappingURL=history-period.enum.js.map